import React from "react";
import { useNavigate } from "react-router-dom";
import { blueTone, toneProps } from "../dashboardTheme";

// Row of small clickable count tiles (HR / CRM snapshots on the dashboard).
// Tiles are shaded light-to-deep blue in order (see blueTone).
// tile: { key, title, icon, value, unit?, hint?, sub, danger?, to }
const CountTiles = ({ tiles, columns = 3 }) => {
  const navigate = useNavigate();
  return (
    <div className={`erp-kpi-grid cols-${columns}`}>
      {tiles.map((t, i) => {
        const { className: toneClass, style: toneStyle } = toneProps(blueTone(i, tiles.length));
        return (
          <button
            type="button"
            key={t.key}
            className={`erp-kpi${toneClass}`}
            style={toneStyle}
            onClick={() => navigate(t.to)}
          >
            <span className="erp-kpi-top">
              <span className="erp-kpi-title">{t.title}</span>
              <span className="erp-icon">{t.icon}</span>
            </span>
            <span className="erp-kpi-valuerow">
              <span className={`erp-kpi-value${t.danger ? " danger" : ""}`} title={t.hint}>
                {t.value}
              </span>
              {t.unit && <span className="erp-kpi-unit">{t.unit}</span>}
            </span>
            <span className="erp-kpi-sub">{t.sub}</span>
          </button>
        );
      })}
    </div>
  );
};

export default CountTiles;
